import React, { Component } from "react";
import {
	ListGroup,
	ListGroupItem,
	Button,
	Card,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
	Form,
	FormGroup,
	Label,
	Input
} from "reactstrap";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faShoppingCart, faMapPin } from "@fortawesome/free-solid-svg-icons";
import { setMarkerData } from "../../actions/mapActions";
import { removeCartItem, createPlanoCampaign } from "../../actions/cartActions";

library.add(faShoppingCart);
library.add(faMapPin);

const base_url_image =
	"https://locauditooh-newapp-gallery.s3.ap-south-1.amazonaws.com/";
const convertion_url = "https://d1of1iagj88x89.cloudfront.net/fit-in/512x512/";

class Cart extends Component {
	state = {
		showCreateCampaignModal: false,
		campaignName: "",
		startDate: "",
		endDate: ""
	};

	handleLocateMarker = item => {
		this.props.setMarkerData(item);
	};

	handleRemoveCartItem = item => {
		this.props.removeCartItem(this.props.cartItems, item);
	};

	handleOnCheckoutClick = item => {
		this.toggle();
	};

	toggle = () => {
		this.setState({
			showCreateCampaignModal: !this.state.showCreateCampaignModal
		});
	};

	createPlanoCampaign = () => {
		const { campaignName, startDate, endDate } = this.state;
		let { createPlanoCampaign, cartItems } = this.props;

		cartItems = cartItems.map(item => item._id);

		if (campaignName.length > 5 && startDate !== "" && endDate !== "") {
			createPlanoCampaign(cartItems, campaignName, startDate, endDate);
		}
	};

	render() {
		const { cartItems } = this.props;

		return (
			<div>
				{cartItems.length !== 0 ? (
					<div>
						<Button
							color="success"
							size="sm"
							onClick={this.handleOnCheckoutClick}
						>
							<FontAwesomeIcon icon="shopping-cart" /> CheckOut
						</Button>
						<Card style={{ height: "600px", overflowY: "scroll" }}>
							<ListGroup>
								{cartItems.map((item, index) => {
									const { site_code, site_map } = item;
									let image_url = "#";
									if (site_map) {
										image_url = site_map;
									}
									return (
										<ListGroupItem key={index}>
											<div className="row">
												<img
													alt={index}
													style={{ cursor: "pointer" }}
													className="col-md-4"
													width="100"
													height="100"
													src={
														// convertion_url +
														// image_url.replace(base_url_image, "")
														image_url
													}
													onClick={() => window.open(image_url, "_blank")}
												/>
												<div className="col-md-8">
													<div className="col-md-12">{site_code}</div>
													<div className="col-md-12">
														<Button
															color="success"
															className="m-1"
															onClick={this.handleLocateMarker.bind(this, item)}
														>
															<FontAwesomeIcon icon="map-pin" />
														</Button>
														<Button
															color="danger"
															className="m-1"
															onClick={this.handleRemoveCartItem.bind(
																this,
																item
															)}
														>
															X
														</Button>
													</div>
												</div>
											</div>
										</ListGroupItem>
									);
								})}
							</ListGroup>
						</Card>
					</div>
				) : (
					<div />
				)}
				<Modal isOpen={this.state.showCreateCampaignModal} toggle={this.toggle}>
					<ModalHeader toggle={this.toggle}>Create Campaign</ModalHeader>
					<ModalBody>
						<Form>
							<FormGroup>
								<Label for="campaignName">Campaign Name</Label>
								<Input
									type="text"
									name="campaignName"
									id="campaignName"
									placeholder="Campaign Name"
									onChange={e => {
										this.setState({ campaignName: e.target.value });
									}}
								/>
							</FormGroup>
							<FormGroup>
								<Label for="startDate">Start Date</Label>
								<Input
									type="date"
									name="startDate"
									id="startDate"
									placeholder="Start Date"
									onChange={e => {
										this.setState({ startDate: e.target.value });
									}}
								/>
							</FormGroup>
							<FormGroup>
								<Label for="endDate">End Date</Label>
								<Input
									type="date"
									name="endDate"
									id="endDate"
									placeholder="End Date"
									onChange={e => {
										this.setState({ endDate: e.target.value });
									}}
								/>
							</FormGroup>
						</Form>
					</ModalBody>
					<ModalFooter>
						<Button color="primary" onClick={this.createPlanoCampaign}>
							Create Campaign
						</Button>
						<Button color="secondary" onClick={this.toggle}>
							Cancel
						</Button>
					</ModalFooter>
				</Modal>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		cartItems: state.cart.cartItems
	};
};

export default connect(
	mapStateToProps,
	{ setMarkerData, removeCartItem, createPlanoCampaign }
)(Cart);



// WEBPACK FOOTER //
// ./src/v3/components/createCampaign/cart.js